import styles from "./SectionHeader.module.css";

export default function SectionHeader({ title, subtitle, action }) {
  return (
    <div className={styles.header}>
      <div>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
      {action ? <button className={styles.action}>{action}</button> : null}
    </div>
  );
}
